import React, { Component } from 'react'
import { graphql, compose, withApollo } from 'react-apollo'

import { AddToPatientList, RemoveFromPatientList, GetPatientList } from '@sukiai/gql/app'
import AddPatientModal from './components/AddPatientModal'
import DeletePatientModal from './components/DeletePatientModal'
import styled from 'styled-components'
import { getStreamWorker } from '../../ws/stream'
import { DataCommand } from '../../ws/DataCommand'
import { LO_STO, FETCH_POLICY, getCompBeingCreated, setCompBeingCreated } from '../../lib'
import { SET_NOTE_CREATED_PENDING } from '../../apollo/actions'
import { logger } from '../../lib/logging'
import FunctionPatientsListContainer from './PatientsListContainer'

import get from 'lodash/get'

import loSto from '../../config/loSto'

export const AddPatientBtn = styled.div`
  border-radius: 4px;
  border: solid 1px rgba(0, 0, 0, 0.25);
  background: transparent;
  color: #000000;
  font-size: 14px;

`
class PatientsListContainer extends Component {
    state = {
      showAddModal: false,
      showDeleteModal: false,
      selectedDeleteId: null
    }

    onAddPatientPrompt = () => {
      // show add patient modal
      this.toggleAddModal(true)
    }

    onDeletePatientPrompt = () => {
      // show delte patient modal
      this.toggleDeleteModal(true)
    }

    toggleAddModal = open => {
      this.setState({ showAddModal: open })
    }

    toggleDeleteModal = open => {
      this.setState({ showDeleteModal: open })
    }

    onAddPatientClose = () => {
      this.toggleAddModal(false)
    }

    onDeletePatientClose = () => {
      this.toggleDeleteModal(false)
    }

    refetchList = (action, id) => {
      const { refetchPatientList } = this.props

      // refetch with additional logging
      refetchPatientList().then(({ data }) => {
        const list = get(data, 'getPatientList.patientList.patients', [])
        logger.info(`PatientList - Action: ${action} | ID: ${id} | refetchList: ${JSON.stringify(list)}`)
      })
    }

    onAddPatient = (patient) => {
      const { addToPatientList } = this.props

      addToPatientList({
        variables: {
          patient,
          userId: loSto.get(LO_STO.USER_ID),
          organizationId: loSto.get(LO_STO.ORGANIZATION_ID)
        }
      }).then(({ data }) => {
        this.refetchList('ADD', patient?.id)
      })
    }

    onDeletePatient = () => {
      const { selectedDeleteId } = this.state
      const { removeFromPatientList } = this.props
      removeFromPatientList({
        variables: {
          id: selectedDeleteId,
          userId: loSto.get(LO_STO.USER_ID),
          organizationId: loSto.get(LO_STO.ORGANIZATION_ID)
        }
      }).then(({ data }) => {
        this.setState({ selectedDeleteId: null })
        this.onDeletePatientClose()
        this.refetchList('DELETE', selectedDeleteId)
      }).catch(err => {
        console.warn('Error Deleting patient', err)
        this.setState({ selectedDeleteId: null })
        this.onDeletePatientClose()
      })
    }

    onDeletePatientClick = (e, patientId) => {
      e.stopPropagation()
      // set state
      this.setState({ selectedDeleteId: patientId }, () => {
        this.onDeletePatientPrompt()
      })
    }

    openNoteTypeSelection = async (patientId) => {
      const {
        client
      } = this.props

      // TODO: Eventually move to using link state for these
      loSto.set(LO_STO.CURRENT_PATIENT_ID, patientId)
      loSto.set(LO_STO.FROM_PATIENT_LIST, true)

      client.mutate({
        mutation: SET_NOTE_CREATED_PENDING,
        variables: {
          isPending: true
        }
      })

      const stream = getStreamWorker()
      stream && stream.postMessage({
        cmd: DataCommand.USER_REQUEST,
        userRequestType: 'CREATE_NOTE',
        userRequestData: { fromPatientList: true },
        ts: new Date().toISOString()
      })

      if (await getCompBeingCreated()) return
      setCompBeingCreated(true)
    }

    render () {
      const { showAddModal, showDeleteModal, selectedDeleteId } = this.state
      const {
        handleModeChange,
        patientList,
        patientListLoading
      } = this.props

      return (
        <div style={{ width: '100vw' }}>
          <FunctionPatientsListContainer
            type='PATIENTS_LIST'
            loading={patientListLoading}
            patientsList={patientList}
            count={patientList.length}
            openNoteTypeSelection={this.openNoteTypeSelection}
            handleModeChange={handleModeChange}
            handleAddPatientPrompt={this.onAddPatientPrompt}
            handleDeletePatientClick={this.onDeletePatientClick}
            fullHeight={!patientListLoading}
          />
          {showAddModal &&
            <AddPatientModal handleAddPatient={this.onAddPatient} handleClose={this.onAddPatientClose} />}

          {showDeleteModal &&
            <DeletePatientModal selectedDeleteId={selectedDeleteId} handleDeletePatient={this.onDeletePatient} handleClose={this.onDeletePatientClose} />}
        </div>
      )
    }
}

const mapPatientListToProps = ({ data }) => {
  const patientList = get(data, 'getPatientList.patientList.patients', [])
  return {
    count: patientList?.length,
    patientList,
    patientListError: data.error,
    patientListLoading: data.loading,
    refetchPatientList: data.refetch
  }
}

export default compose(
  withApollo,
  graphql(GetPatientList, {
    skip: () => !loSto.get(LO_STO.USER_ID) || !loSto.get(LO_STO.ORGANIZATION_ID),
    options: () => ({
      variables: {
        userId: loSto.get(LO_STO.USER_ID),
        organizationId: loSto.get(LO_STO.ORGANIZATION_ID)
      },
      fetchPolicy: FETCH_POLICY.CACHE_AND_NETWORK
    }),
    props: mapPatientListToProps
  }),
  graphql(AddToPatientList, { name: 'addToPatientList' }),
  graphql(RemoveFromPatientList, { name: 'removeFromPatientList' })
)(PatientsListContainer)
